export default async ({ store }) => {
  await store.dispatch('plataforma/institutionConfiguration/actionInitTopicTypes', _, { root: true });
};
